import React from 'react'
import PropTypes from 'prop-types'

import { getOrgInitials } from '../../utils/organization'

const OrgAvatar = props => (
  <div className="org-avatar">
    {props.organization.photo && <img src={props.organization.photo} />}
    {!props.organization.photo && (
      <div className="placeholder">{getOrgInitials(props.organization)}</div>
    )}
  </div>
)

OrgAvatar.propTypes = {
  organization: PropTypes.object.isRequired
}

export default OrgAvatar



// WEBPACK FOOTER //
// ./src/components/mini/OrgAvatar.js